import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { Form } from "react-bootstrap";
import FormSection from "components/Form/formSection/FormSection";
import { FormData } from "models/Form";
import { Button, ResponseHandler } from "components";
import MobileViewButton from "pages/PickPack/components/MobileViewButton";
import { ReactComponent as ViewIcon } from "assets/icons/view-fill.svg";
import { KitchenFormNewProps } from "./KitchenForm.props";
import "./kitchenForm.scss";

const FormNew: React.FC<KitchenFormNewProps> = (props) => {
    const formRef = useRef<HTMLFormElement>(null);
    const {
        formData,
        formTitle,
        getFormData,
        costumeTitle,
        updateFormData,
        handleChange,
        ExtraTitleComponent,
        updateData,
        updateLoading,
        disableSubmit,
        startDate,
        className,
        ExtraField,
        isDisable,
        ExtraTabComponent,
        disableSubmitBtn,
        isMobileView = false,
        handleModalPreview,
        containedTitle,
        outlinedTitle,
        hasError,
        renderUI = true,
    } = props;

    const { pathname } = useLocation();
    const isShelfUpdatePage = pathname.includes("update-shelf");

    const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        let dataCopy = [...formData];
        for (let section of dataCopy) {
            for (let input of section.inputs) {
                if (formRef.current) {
                    for (let i = 0; i < formRef.current?.length; i++) {
                        if (
                            input.name ===
                            (formRef.current[i] as HTMLFormElement).name
                        ) {
                            if (
                                input.type === "tag" &&
                                formRef.current[i].getAttribute("data-value")
                            ) {
                                const tagValue = (
                                    formRef.current[i] as HTMLFormElement
                                )?.getAttribute("data-value");
                                input.value = tagValue?.split(/[,\-_]/);
                            } else {
                                input.value = (
                                    formRef.current[i] as HTMLFormElement
                                )?.value;
                            }
                        }
                    }
                }
            }
        }

        const unmergedObj: Record<string, any> = {};

        for (let i = 0; i < dataCopy[0].inputs.length; i++) {
            unmergedObj[dataCopy[0].inputs[i].name] =
                dataCopy[0].inputs[i].type === "select" ||
                dataCopy[0].inputs[i].type === "number"
                    ? Number(dataCopy[0].inputs[i].value)
                    : dataCopy[0].inputs[i].value;
        }
        updateData
            ? updateFormData({
                  ...(unmergedObj as FormData),
                  id: updateData ? updateData.id : null,
              })
            : getFormData(unmergedObj as FormData);
    };

    return (
        formData && (
            <Form
                className={`${className}`}
                onSubmit={handleSubmit}
                ref={formRef}
            >
                {!isMobileView && (
                    <div className="title-container d-flex align-items-center pb-0">
                        {formTitle && <h5 className="ml-auto">{formTitle}</h5>}
                        {ExtraTitleComponent}
                        <div className="action-btns-container">
                            <Button
                                size="lg"
                                className="solid is-green half-height"
                                disabled={
                                    disableSubmitBtn
                                        ? disableSubmitBtn
                                        : pathname.includes("view")
                                          ? true
                                          : updateData
                                            ? false
                                            : disableSubmit
                                }
                                handleClick={handleSubmit}
                                btnText={updateData ? "ذخیره" : "ثبت"}
                            />
                            {isShelfUpdatePage && (
                                <div className="shelf-template">
                                    <Button
                                        size="lg"
                                        className="half-height bordered"
                                        handleClick={() =>
                                            handleModalPreview &&
                                            handleModalPreview(true)
                                        }
                                        btnIcon={<ViewIcon />}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {ExtraTabComponent}
                <ResponseHandler
                    loading={updateLoading}
                    response={formData}
                    error={false}
                    isInput={true}
                    noDataText="آیتمی وجود ندارد"
                >
                    <>
                        {renderUI &&
                            formData.map((section: any) => (
                                <FormSection
                                    section={section}
                                    defaultValues={updateData}
                                    handleChange={(name, value) =>
                                        handleChange?.(name, value)
                                    }
                                    hasError={hasError}
                                    key={section.name}
                                    startDate={startDate}
                                    costumeTitle={costumeTitle}
                                    isDisable={isDisable}
                                />
                            ))}
                        {ExtraField}
                    </>
                </ResponseHandler>

                {isMobileView && (
                    <MobileViewButton
                        containedTitle={containedTitle}
                        outlinedTitle={outlinedTitle}
                        handleClickContained={handleSubmit}
                        bordered
                        contained
                        outlined={pathname.includes("update-shelf")}
                        handleClickOutlined={() =>
                            handleModalPreview && handleModalPreview(true)
                        }
                    />
                )}
            </Form>
        )
    );
};

export default FormNew;
